export class SidebarSettingsModel {
  isHidden: boolean;

  constructor(isHidden: boolean) {
    this.isHidden = isHidden ? isHidden : false;
  }
}
